// Phase 2: supported country codes for the Horn of Africa.
// 251 = Ethiopia, 252 = Somalia, 253 = Djibouti (default).

export interface CountryInfo {
  code: string; // "+251"
  dialCode: string; // "251"
  name: string;
  flag: string; // emoji
  currency: string; // ISO 4217
  currencySymbol: string;
}

export const COUNTRIES: CountryInfo[] = [
  {
    code: "+253",
    dialCode: "253",
    name: "Djibouti",
    flag: "🇩🇯",
    currency: "DJF",
    currencySymbol: "Fdj",
  },
  {
    code: "+251",
    dialCode: "251",
    name: "Ethiopia",
    flag: "🇪🇹",
    currency: "ETB",
    currencySymbol: "ETB",
  },
  {
    code: "+252",
    dialCode: "252",
    name: "Somalia",
    flag: "🇸🇴",
    currency: "SOS",
    currencySymbol: "Sh",
  },
];

export const DEFAULT_COUNTRY_CODE = "+253";

export function getCountry(code: string | null | undefined): CountryInfo {
  return COUNTRIES.find((c) => c.code === code) ?? COUNTRIES[0];
}

// Normalize a phone number against a country code.
// Accepts "0912..." or "251912..." or "+251912..." forms and returns "+251912...".
export function normalizePhone(raw: string, countryCode: string = DEFAULT_COUNTRY_CODE): string {
  if (!raw) return "";
  let s = raw.replace(/[\s\-()]/g, "");
  if (s.startsWith("+")) return s;
  const dial = countryCode.replace("+", "");
  if (s.startsWith(dial)) return "+" + s;
  if (s.startsWith("00")) return "+" + s.slice(2);
  // Local format — strip leading 0 and prepend country dial code.
  if (s.startsWith("0")) s = s.slice(1);
  return `${countryCode}${s}`;
}

// Validate phone number basic shape for the given country.
export function isValidPhone(raw: string, countryCode: string = DEFAULT_COUNTRY_CODE): boolean {
  const normalized = normalizePhone(raw, countryCode);
  // +country_code followed by 7-12 digits.
  return /^\+\d{7,15}$/.test(normalized);
}
